import { render, staticRenderFns } from "./prizeClaw.vue?vue&type=template&id=24600cb4&scoped=true&"
import script from "./prizeClaw.vue?vue&type=script&lang=js&"
export * from "./prizeClaw.vue?vue&type=script&lang=js&"
import style0 from "./prizeClaw.vue?vue&type=style&index=0&id=24600cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24600cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24600cb4')) {
      api.createRecord('24600cb4', component.options)
    } else {
      api.reload('24600cb4', component.options)
    }
    module.hot.accept("./prizeClaw.vue?vue&type=template&id=24600cb4&scoped=true&", function () {
      api.rerender('24600cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/prizeClaw.vue"
export default component.exports